import { TextbookList } from '@/api/teacher'
/**
 * 教师端
 */

// 教师-查询新账号
const TeacherQueryAccount_field = [
    {
        label: "原账号",
        field: "old_emp_no",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "el-icon-user",
        input_tips: "请输入原登录账号",
        setting: [],
        required: 1,
    },
    {
        label: "原密码",
        field: "old_pwd",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入原登录密码",
        setting: [],
        required: 1,
    }
]
// 教师登录
const TeacherLogin_field = [
    {
        label: "账号",
        field: "emp_no",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "el-icon-user",
        input_tips: "请输入登录账号",
        setting: [],
        required: 1,
    },
    {
        label: "密码",
        field: "password",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入登录密码",
        setting: [],
        required: 1,
    }
]

// 教师-修改资料
const TeacherInfo_field = [
    {
        label: "真实姓名",
        field: "realname",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入真实姓名",
        setting: [],
        required: 1,
    },
    {
        label: "手机号",
        field: "mobile",
        form_type: "mobile",
        default_value: "",
        value: "",
        input_tips: "请输入手机号",
        setting: [],
        required: 1,
    },
    {
        label: "性别",
        field: "sex",
        form_type: "select",
        default_value: 1,
        value: "",
        input_tips: "请选择性别",
        setting: [
            {
                label: '男',
                value: 1,
            },
            {
                label: '女',
                value: 2,
            },
            {
                label: '保密',
                value: 3,
            },
        ],
        required: 1,
    },
    {
        label: "年龄",
        field: "age",
        form_type: "number",
        default_value: "",
        value: "",
        input_tips: "请输入年龄",
        setting: [],
        required: 1,
    },
    {
        label: "邮箱",
        field: "email",
        form_type: "email",
        default_value: "",
        value: "",
        input_tips: "请输入邮箱",
        setting: [],
        required: 1,
    },
    {
        label: "QQ号",
        field: "qq",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入QQ号",
        setting: [],
        required: 1,
    },
    {
        label: "微信号",
        field: "weixin",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入微信号",
        setting: [],
        required: 1,
    },
    {
        label: "详细地址",
        field: "address",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入详细地址",
        setting: [],
        required: 1,
    },
    
]
// 教师-修改密码
const TeacherPassword_field = [
    {
        label: "原密码",
        field: "old_password",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入原密码",
        setting: [],
        required: 1,
    },
    {
        label: "新密码",
        field: "password",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入新密码",
        setting: [],
        required: 1,
    },
    {
        label: "确认密码",
        field: "password_confirm",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请再次输入密码",
        setting: [],
        required: 1,
    },
]

// 教师-班级搜索
const TeacherSearchClass_field = [
    {
        label: "班级名称",
        field: "li_name",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入班级名称",
        setting: [],
        required: 0,
    },
    {
        label: "班级说明",
        field: "li_content",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入班级说明",
        setting: [],
        required: 0,
    },
    {
        label: "班级状态",
        field: "eq_is_valid",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择",
        setting: [
            {
                label: '启用',
                value: 1,
            },
            {
                label: '禁用',
                value: 2,
            }
        ],
        required: 0,
    }
]

// 教师-新增班级
const TeacherAddClass_field = [
    {
        label: "班级名称",
        field: "name",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入班级名称",
        setting: [],
        required: 1,
    },
    {
        label: "班号",
        field: "class_code",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入班号",
        setting: [],
        required: 1,
    },
    {
        label: "年级",
        field: "grade",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择年级",
        setting: [],
        required: 1,
    },
    {
        label: "班级说明",
        field: "content",
        form_type: "textarea",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入班级说明",
        setting: [],
        required: 1,
    },
    {
        label: "班级人数",
        field: "class_num",
        form_type: "number",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入班级人数",
        setting: [],
        required: 1,
    },
    {
        label: "班级状态",
        field: "state",
        form_type: "radio",
        default_value: 1,
        value: "",
        icon: "",
        input_tips: "",
        setting: [
            {
                label: '启用',
                value: 1,
            },
            {
                label: '关闭',
                value: 2,
            },
        ],
        required: 1,
    },
]
// 删除学生
const TeacherDelStudent_field = [
    {
        label: "班级名称",
        field: "class_id",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择班级",
        setting: [],
        required: 1,
    },
    {
        label: "学员账号",
        field: "emp_no",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "学员账号",
        setting: [],
        required: 1,
    },
    {
        label: "教师密码",
        field: "password",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入教师密码",
        setting: [],
        required: 1,
    }
]

// 教师-学员搜索
const TeacherSearchStudent_field = [
    {
        label: "班级名称",
        field: "class_id",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择",
        setting: [],
        required: 0,
    },
    {
        label: "学员账号",
        field: "emp_no",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    },
    {
        label: "学员状态",
        field: "state",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择",
        setting: [
            {
                label: '启用',
                value: 1,
            },
            {
                label: '禁用',
                value: 2,
            }
        ],
        required: 0,
    },
]

// 教师-开课记录搜索
const TeacherSearchCourseCard_field = [
    {
        label: "开课卡号",
        field: "li_card_account",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    },
    {
        label: "开课时间",
        field: "create_time_range",
        form_type: "daterange",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    }
]

// 教师-新增学员
const TeacherAddStudent_field = [
    {
        label: "班级名称",
        field: "teacher_class_id",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择班级",
        setting: [],
        required: 1,
    },
    {
        label: "学员姓名",
        field: "student_id",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "选择学员",
        setting: [],
        required: 1,
        filterable: 1,
    },
    {
        label: "教师密码",
        field: "password",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入教师密码",
        setting: [],
        required: 1,
    }
]

// 重置学生密码
const ResetPasswordStudent_field = [
    {
        label: "学员",
        field: "realname",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "",
        setting: [],
        disabled: true
    },
    {
        label: "学生ID",
        field: "student_id",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "",
        setting: [],
        required: 1,
        disabled: true
    },
    {
        label: "新密码",
        field: "password",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入新密码",
        setting: [],
        required: 1,
    },
    {
        label: "确认密码",
        field: "password_confirm",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请再次输入密码",
        setting: [],
        required: 1,
    }
]

// 保存课程
const TeacherStudentCourse_field = [
    {
        label: "学员ID",
        field: "student_id",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "",
        setting: [],
        hidden: true
    },
    {
        label: "选择课本",
        field: "curriculum_id",
        form_type: "select_course",
        default_value: "",
        value: "",
        input_tips: "请选择课本",
        setting: [],
        required: 1,
    },
    {
        label: "开课卡号",
        field: "card_code",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "",
        setting: [],
        required: 1,
    },
    {
        label: "卡号密码",
        field: "password",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入新密码",
        setting: [],
        required: 1,
    }
]

// 教师-测试搜索
const TeacherSearchRecord_field = [

    {
        label: "分类",
        field: "type",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
        hidden: true
    },
    {
        label: "学员名称",
        field: "student_id",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择",
        setting: [],
        required: 0,
    },
    {
        label: "所在班级",
        field: "class_id",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择",
        setting: [],
        required: 0,
    },
    {
        label: "课程名称",
        field: "curriculum_name",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    },
    {
        label: "是否通过",
        field: "is_pass",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择",
        setting: [
            {
                label: '通过',
                value: 1,
            },
            {
                label: '未通过',
                value: 0,
            }
        ],
        required: 0,
    },
]





/**
 * 家长端
 */
// 修改资料
const ParentInfo_field = [
    {
        label: "头像",
        field: "avatar",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请选择头像",
        setting: [],
        hidden: 1
    },
    {
        label: "真实姓名",
        field: "realname",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入真实姓名",
        setting: [],
        required: 1,
    },
    {
        label: "手机号",
        field: "mobile",
        form_type: "mobile",
        default_value: "",
        value: "",
        input_tips: "请输入手机号",
        setting: [],
        required: 1,
    },
    {
        label: "性别",
        field: "sex",
        form_type: "select",
        default_value: "",
        value: "",
        input_tips: "请选择性别",
        setting: [
            {
                label: '男',
                value: 1,
            },
            {
                label: '女',
                value: 2,
            },
            {
                label: '保密',
                value: 3,
            },
        ],
        required: 1,
    },
    {
        label: "年龄",
        field: "age",
        form_type: "number",
        default_value: "",
        value: "",
        input_tips: "请输入年龄",
        setting: [],
    },
    {
        label: "邮箱",
        field: "email",
        form_type: "email",
        default_value: "",
        value: "",
        input_tips: "请输入邮箱",
        setting: [],
    },
    {
        label: "QQ号",
        field: "qq",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入QQ号",
        setting: [],
    },
    {
        label: "微信号",
        field: "wx_code",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入微信号",
        setting: [],
    },
    {
        label: "详细地址",
        field: "address",
        form_type: "text",
        default_value: "",
        value: "",
        input_tips: "请输入详细地址",
        setting: [],
    },
    
]
// 修改密码
const ParentPassword_field = [
    {
        label: "原密码",
        field: "old_pwd",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入原密码",
        setting: [],
        required: 1,
    },
    {
        label: "新密码",
        field: "pwd",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请输入新密码",
        setting: [],
        required: 1,
    },
    {
        label: "确认密码",
        field: "new_pwd",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "el-icon-lock",
        input_tips: "请再次输入密码",
        setting: [],
        required: 1,
    },
]
// 学员搜索
const ParentSearchStudent_field = [
    {
        label: "学员账号",
        field: "emp_no",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    },
    {
        label: "手机号",
        field: "mobile",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    },
    {
        label: "学员性别",
        field: "sex",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请选择",
        setting: [
            {
                label: '男',
                value: 1,
            },
            {
                label: '女',
                value: 2,
            },
            {
                label: '保密',
                value: 3,
            }
        ],
        required: 0,
    },
]
//竞赛类型搜索
const ParentSearchRace_field = [
    {
        label: "测试类型",
        field: "test_type",
        form_type: "select",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    },
    {
        label: "学员名称",
        field: "realname",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入",
        setting: [],
        required: 0,
    },
]


// 教师-新增学员
const ParentAddStudent_field = [
    {
        label: "学员账号",
        field: "emp_no",
        form_type: "text",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入学员",
        setting: [],
        required: 1,
    },
    {
        label: "学员密码",
        field: "pwd",
        form_type: "password",
        default_value: "",
        value: "",
        icon: "",
        input_tips: "请输入学员密码",
        setting: [],
        required: 1,
    }
]

/**
 * 学生端
 */


export {
    TeacherInfo_field,
    TeacherPassword_field,
    TeacherQueryAccount_field,
    TeacherLogin_field,
    TeacherAddClass_field,
    TeacherSearchClass_field,
    TeacherDelStudent_field,
    TeacherSearchStudent_field,
    TeacherSearchCourseCard_field,
    ResetPasswordStudent_field,
    TeacherAddStudent_field,
    TeacherStudentCourse_field,
    TeacherSearchRecord_field,
    ParentInfo_field,
    ParentPassword_field,
    ParentSearchStudent_field,
    ParentSearchRace_field,
    ParentAddStudent_field
}
